// src/com/login/MaskDsc.js
import React, { useEffect } from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import { Button, DialogActions, DialogContent } from '@mui/material';
import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency';
import HomeWorkIcon from '@mui/icons-material/HomeWork'; // Mark my center.
import KeyIcon from '@mui/icons-material/Key'; // 전환.
import KeyOffIcon from '@mui/icons-material/KeyOff'; // 해제.
import CloseIcon from '@mui/icons-material/Close';
import DraggableViewer from '../../common/DraggableViewer';
import { dcInfoListRepo, userInfoRepo } from '../../value/AppModel';
import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { AppObject, AppStyle, AppWord } from '../../value/AppConst';
import { LIST_DC_INFO } from '../dc_info/DcInfoGql';
import { useAlertSetter } from '../../api/app-hook';

const DcListContainer = styled(Box)({
    maxHeight: '80vh', overflow: 'auto'
});

const DcLineBox = styled(Box)({
    display: 'inline-flex', alignItems: 'center', border: AppStyle.BorderCCC,
    borderRadius: 5, margin: 4, padding:2, placeSelf: 'stretch',
    '&:hover': {backgroundColor: '#f0f0f0', border: '1px solid #f00'}
});

const DcName = styled(Box)({
    flexGrow: 1, padding: '5px 10px 5px 10px', minWidth: 120, fontSize: '0.9rem', textAlign: 'left'
});
const DcCode = styled('span')({
    fontSize: '0.75rem', color: '#888'
});

const ButtonBox = styled(Box)({
    padding: '5px 10px 5px 10px', minWidth: 70,
    display: 'flex', justifyContent: 'end'
});

/**
 * MaskDsc. 센터 전환을 위한 View.
 * 처리는 onRequestMask를 호출하여 상위 컴포넌트에서 처리한다.
 * @param {*} param0 
 */
export default function MaskDsc({
    open,
    onClose,
    onRequestMask, // (dcInfoItem) => {}
    working, // true: 전환 처리중, false: 전환 처리중 아님.
}) {
    const sessionInfo = useReactiveVar(userInfoRepo);
    const dcInfoListData = useReactiveVar(dcInfoListRepo);
    const addAlert = useAlertSetter();

    // ##### Call GraphQL to get List #####
    const [getDcInfoList, responseDcList] = useLazyQuery(LIST_DC_INFO, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetDcList(data, option)},
		onError: (error) => addAlert({title: '출발지 목록 조회 오류', message: [error.message]})
    });

    useEffect(()=>{
        if(open) {
            const diff = new Date().getTime()/1000 - dcInfoListData.when;
            if(diff > 600) getDcInfoList();
        }
    }, [dcInfoListData, open]);

    // >>>>>>>>> callbacks <<<<<<<<<<<<<
    const onCompleteGetDcList = (data, clientOption) => {
        if(data.dcInfoList) {
            dcInfoListRepo({when:new Date().getTime()/1000, records:data.dcInfoList});
        }
    };

    const onClickMask = (dcInfoItem) => {
        if(sessionInfo.user.allDcYn === 'Y') onRequestMask(dcInfoItem);
    };

    /**
     * 전환 해제 버튼 클릭.
     * 자신의 센터 정보를 사용하여 전환을 해제한다.
     */
    const onClickUnmask = () => {
        onRequestMask(); // 전환 해제.
    };

    return(
        <DraggableViewer
            open={open} maxWidth='lg'
            onClose={onClose}
            title='센터 전환'
            startIcon={<ContactEmergencyIcon fontSize={AppWord.LARGE} />}
        >
            <DialogContent style={{textAlign:'center'}}>
                <DcListContainer>
                    {
                        dcInfoListData.records.map((dcInfoItem) => {
                            return(
                                <DcLineBox key={dcInfoItem.dcCd}>
                                    <DcName>
                                        <DcCode>[{dcInfoItem.dcCd}]</DcCode>
                                        {dcInfoItem.dcName}
                                    </DcName>
                                    <ButtonBox>
                                        {
                                            sessionInfo.user.dscId === dcInfoItem.dcCd
                                            ?
                                            <HomeWorkIcon style={{color:AppStyle.HomeplusRed}}/>
                                            :
                                            sessionInfo.user.dscIdAs === dcInfoItem.dcCd
                                            ?
                                            <Button
                                                variant={AppStyle.mui.contained}
                                                color={AppStyle.mui.secondary}
                                                startIcon={<KeyOffIcon />}
                                                onClick={() => onClickUnmask()}
                                                size={AppWord.SMALL}
                                                disabled={working}
                                            >
                                                해제
                                            </Button>
                                            :
                                            <Button
                                                variant={AppStyle.mui.contained}
                                                color={AppStyle.mui.inherit}
                                                startIcon={<KeyIcon />}
                                                onClick={() => onClickMask(dcInfoItem)}
                                                size={AppWord.SMALL}
                                                disabled={working}
                                            >
                                                전환
                                            </Button>
                                        }
                                    </ButtonBox>
                                </DcLineBox>
                            )
                        })
                    }
                </DcListContainer>
            </DialogContent>
            <DialogActions>
                <Box style={{textAlign:'center', width:'100%'}}>
                    <Button
                        variant={AppStyle.mui.contained}
                        color={AppStyle.mui.inherit}
                        onClick={onClose}
                        startIcon={<CloseIcon />}
                    >
                        닫기
                    </Button>
                </Box>
            </DialogActions>
        </DraggableViewer>
    );
}